import { objectGetKeys } from '../../../utils/ieCompatibility'

export enum AppartementGenreEnum {
	PIECES2 = 221310000,
	PIECES3 = 221310001,
	PIECES4 = 221310002,
	PIECES5 = 221310003,
	PIECES6 = 221310004,
	PIECES7 = 221310005,
	CHAMBRE = 221310018,
	STUDIO = 221310068,
	T1 = 221310069,
	T1BIS = 221310070,
	T2 = 221310071,
	T3 = 221310072,
	T4 = 221310073,
	T5 = 221310074,
	T6 = 221310075,
	T8 = 221310076,
}

export const getKeyFromAppartementGenreValue = (value: number) => objectGetKeys(AppartementGenreEnum).find((appartementGenre) => AppartementGenreEnum[appartementGenre as keyof typeof AppartementGenreEnum] === value)